export const Footer = () => {
    const year = new Date().getFullYear();

    return <footer className="footer text-center text-lg-start text-muted">

        <div className="container text-md-start mt-2">
            {/* Grid row */}
            <div className="row mt-3">
                {/* Grid column */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto ">
                    {/* Links */}
                    <h6 className="text-uppercase fw-bold ">
                        <a className="text-reset" target="_blank" href="https://www.streck.com/">Streck.com</a>
                    </h6>
                </div>

                {/* Grid column */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto ">
                    {/* Links */}
                    <h6 className="text-uppercase fw-bold ">
                        <a className="text-reset" target="_blank" href="https://www.streck.com/legal-privacy/">Privacy Policy</a>
                    </h6>
                </div>

                {/* Grid column */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto ">
                    {/* Links */}
                    <h6 className="text-uppercase fw-bold ">
                        <a className="text-reset" target="_blank" href="https://www.streck.com/contact/">Contact</a>
                    </h6>
                </div>

                {/* Grid column */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto ">
                    {/* Links */}
                    <h6 className="text-uppercase fw-bold ">
                        800-843-0912
                    </h6>
                </div>

                {/* Copyright */}
                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto ">
                    {/* Links */}
                    <h6 className="text-uppercase fw-bold ">
                        ©Streck LLC {year}
                    </h6>
                </div>
            </div>
            {/* Grid row */}
        </div>

    </footer>;
};

